module.exports = __webpack_public_path__ + "img/p-one-step-12.dc5bf40d.png";